<script>
export default {
  name: "agentsRegistration"
};
</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="agents-reg-img" style="padding: 16px">
        <el-row class="backdrop" style="padding: 22px">
          <el-col :span="24" style="display: flex; justify-content: center">
            <img
              loading="lazy"
              src="../../assets/are-you-real-estate-agent.svg"
            />
          </el-col>
          <el-col
            :span="24"
            style="display: flex; justify-content: center; margin-top: 22px"
          >
            <span class="agent-title"
              >Do you want to list on UNIFI Property?</span
            >
          </el-col>
          <el-col :span="24" style="display: flex; justify-content: center">
            <span class="agent-paragraph"
              >Register to start listing your properties on UNIFI Property</span
            >
          </el-col>
          <el-col :span="24" style="display: flex; justify-content: center">
            <el-button class="agent-registration-btn" type="primary"
              >Register</el-button
            >
          </el-col>
        </el-row>
        <el-row class="backdrop" style="padding: 22px; margin-top: 40px">
          <el-col :span="24" style="display: flex; justify-content: center">
            <img
              loading="lazy"
              src="../../assets/are-you-in-the-finance-industry.svg"
            />
          </el-col>
          <el-col
            :span="24"
            style="display: flex; justify-content: center; margin-top: 31px"
          >
            <span class="agent-title"
              >Introducing property to your clients?</span
            >
          </el-col>
          <el-col :span="24" style="display: flex; justify-content: center">
            <span class="agent-paragraph"
              >Real Estate Agents, Buyers Agents, Mortgage Brokers, Accountants,
              Advisers and Migration Agents</span
            >
          </el-col>
          <el-col :span="24" style="display: flex; justify-content: center">
            <el-button class="agent-registration-btn" type="primary"
              >Register</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.agents-reg-img {
  display: flex;
  //width: 375px;
  //padding: 14.512px 16px 15.488px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.3) 100%
    ),
    url("../../assets/registration-box.jpg"),
    lightgray -488px -346.674px / 539.467% 186.063% no-repeat;
}

.agent-registration-btn {
  color: #ffbe00;
  text-align: center;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  width: 100%;
  margin-top: 24px;
  font: 600 20px Metropolis, sans-serif;
}

.agent-title {
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.agent-paragraph {
  color: #fff;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.backdrop {
  background: rgba(0, 0, 0, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/package/agentsRegistration.vue